// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "c7c9f04";
